export const RIGHT_SIDEBAR = 'right-sidebar';
export const LEFT_SIDEBAR = 'left-sidebar';
